import { addBusinessDays } from "date-fns";

export const getNthBusinessDayToDate = (startDate: Date, x: number): Date => {
	if (x < 1) return startDate;

	const isStartDayBusinessDay = startDate.getDay() !== 0 && startDate.getDay() !== 6;
	return addBusinessDays(startDate, isStartDayBusinessDay ? x : x - 1);
};
